<template>
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
            fill="url(#paint0_linear_13713_80594)"
        />
        <path
            d="M20.0904 5.81836H11.8736C10.2683 5.82028 8.7292 6.45887 7.59403 7.59403C6.45887 8.7292 5.82028 10.2683 5.81836 11.8736V20.0918C5.82067 21.6969 6.45942 23.2356 7.59455 24.3705C8.72967 25.5053 10.2685 26.1437 11.8736 26.1456H20.0918C21.6969 26.1433 23.2356 25.5046 24.3705 24.3694C25.5053 23.2343 26.1437 21.6955 26.1456 20.0904V11.8736C26.1437 10.2685 25.5053 8.72967 24.3705 7.59455C23.2356 6.45942 21.6969 5.82067 20.0918 5.81836L20.0904 5.81836ZM24.102 20.0904C24.1022 20.6172 23.9986 21.139 23.797 21.6258C23.5955 22.1126 23.3 22.5549 22.9274 22.9274C22.5549 23.3 22.1126 23.5955 21.6258 23.797C21.139 23.9986 20.6172 24.1022 20.0904 24.102H11.8736C11.3469 24.102 10.8253 23.9982 10.3387 23.7966C9.85203 23.595 9.40989 23.2995 9.03749 22.9269C8.66509 22.5544 8.36973 22.1121 8.16829 21.6254C7.96684 21.1387 7.86326 20.6171 7.86345 20.0904V11.8736C7.86345 10.8101 8.28595 9.79006 9.03801 9.03801C9.79006 8.28595 10.8101 7.86345 11.8736 7.86345H20.0918C21.1554 7.86345 22.1754 8.28595 22.9274 9.03801C23.6795 9.79006 24.102 10.8101 24.102 11.8736V20.0918V20.0904Z"
            fill="white"
        />
        <path
            d="M15.9828 10.7246C14.5887 10.7261 13.2522 11.2806 12.2664 12.2664C11.2806 13.2522 10.7261 14.5887 10.7246 15.9828C10.7265 17.3766 11.2812 18.7128 12.2669 19.6982C13.2526 20.6837 14.589 21.238 15.9828 21.2395C17.3764 21.2376 18.7123 20.6831 19.6977 19.6977C20.6831 18.7123 21.2376 17.3764 21.2395 15.9828C21.238 14.589 20.6837 13.2526 19.6982 12.2669C18.7128 11.2812 17.3766 10.7265 15.9828 10.7246V10.7246ZM15.9828 19.1944C15.5552 19.2035 15.1301 19.1272 14.7324 18.9698C14.3347 18.8125 13.9724 18.5773 13.6667 18.2781C13.3611 17.9789 13.1183 17.6217 12.9525 17.2274C12.7867 16.8332 12.7013 16.4098 12.7013 15.9821C12.7013 15.5544 12.7867 15.131 12.9525 14.7367C13.1183 14.3424 13.3611 13.9852 13.6667 13.686C13.9724 13.3868 14.3347 13.1517 14.7324 12.9943C15.1301 12.837 15.5552 12.7606 15.9828 12.7697C16.8229 12.7876 17.6226 13.1339 18.2105 13.7344C18.7983 14.3349 19.1275 15.1417 19.1275 15.9821C19.1275 16.8224 18.7983 17.6293 18.2105 18.2298C17.6226 18.8303 16.8229 19.1766 15.9828 19.1944Z"
            fill="white"
        />
        <path
            d="M21.2495 12.2187C22.0528 12.2187 22.704 11.5674 22.704 10.7641C22.704 9.96079 22.0528 9.30957 21.2495 9.30957C20.4461 9.30957 19.7949 9.96079 19.7949 10.7641C19.7949 11.5674 20.4461 12.2187 21.2495 12.2187Z"
            fill="white"
        />
        <defs>
            <linearGradient
                id="paint0_linear_13713_80594"
                x1="16"
                y1="31.9069"
                x2="16"
                y2="0.24864"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#E09B3D" />
                <stop offset="0.3" stop-color="#C74C4D" />
                <stop offset="0.6" stop-color="#C21975" />
                <stop offset="1" stop-color="#7024C4" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
export default {
    name: "InstagramLogo",
};
</script>
